/**
 * CareStart product-path helpers for the global Settings gear and TTS wiring.
 *
 * Matches interview surfaces that use CareStart TTS helpers. Excludes Studio
 * (clinic prompt/variant config) and the public help FAQ.
 */

/**
 * @param {string} [pathname]
 * @returns {boolean}
 */
export function isCareStartProductPath(pathname = '') {
  if (typeof pathname !== 'string') return false;
  const normalized = pathname.replace(/\/+$/, '') || '/';

  if (normalized === '/carestart/help' || normalized.startsWith('/carestart/help/')) {
    return false;
  }
  if (
    normalized === '/carestart-studio' ||
    normalized.startsWith('/carestart-studio/') ||
    normalized === '/dashboard/carestart-studio' ||
    normalized.startsWith('/dashboard/carestart-studio/')
  ) {
    return false;
  }

  if (normalized === '/carestart' || normalized.startsWith('/carestart/')) {
    return true;
  }
  if (normalized === '/carestart3' || normalized.startsWith('/carestart3/')) {
    return true;
  }
  if (
    normalized === '/carestart-plus/hpi' ||
    normalized.startsWith('/carestart-plus/hpi/')
  ) {
    return true;
  }

  return false;
}
